import { getJobProfileAsOptions } from "../../config/jobprofile.config";
import { LocationOptions } from "../Register/CompanyDetails";

export const dropdownOptions = {
    employeeLocation: [
      { value: '', label: 'Select Employee Location' },
      // { value: 'india', label: 'India' },
      // { value: 'usa', label: 'USA' },
      // { value: 'dubai', label: 'Dubai' },
      ...LocationOptions
    ],
    employmentType: [
      { value: '', label: 'Select Employment Type' },
      { value: 'Full Time', label: 'Full Time' },
      { value: 'Internship', label: 'Internship' },
      {value: 'Part Time', label: 'Part Time'},
      { value: 'Contract', label: 'Contract' },
    ],
    jobProfile: [
        { value: '', label: 'Select Job Profile' },
        ...getJobProfileAsOptions()
    ],
    workplaceType: [
      { value: '', label: 'Select Workplace Type' },
      { value: 'On-Site', label: "On-Site" },
      { value: 'Remote', label: "Remote" },
      { value: 'Hybrid', label: "Hybrid" }
    ]
  };

  export const dummySkills = [
    "User Experience (UX) Design",
    "User Interface (UI) Design",
    "Wireframing",
    "Prototyping",
    "Information Architecture",
    "Visual Design",
    "Color Theory",
    "Typography",
    "Interaction Design",
    "Motion Graphics",
    "Iconography",
    "Branding and Identity Design",
    "Layout and Composition",
    "Design Systems and Style Guides",
    "Responsive Design",
    "Design Thinking",
    "Usability Testing",
    "Accessibility Design",
    "Information Visualization",
    "3D Modeling and Rendering",
    "Illustration",
    "Front-End Design Integration",
    "Design Software Proficiency ",
    "Figma",
    "Sketch",
    "Adobe XD",
    "Collaboration and Communication",
    "Continuous Learning and Adaptability",
    "JavaScript",
    "React",
    "Node.js",
    "Python",
    "Java",
    "C++",
    "HTML",
    "CSS",
    "TypeScript",
    "Ruby",
    "PHP",
    "Swift",
    "Kotlin",
    "Go",
    "Rust",
    "SQL",
    "MongoDB",
    "GraphQL",
    "Docker",
    "Kubernetes",
    "AWS",
    "Azure",
    "Google Cloud",
    "Machine Learning",
    "Artificial Intelligence",
    "Data Science",
    "Blockchain",
    "IoT",
    "Cyber Security",
    "DevOps"
  ];